import { Component, Inject, OnInit } from '@angular/core'
import { LocalStorageService } from '../../services/utils/local-storage.service'
import { OperatorService } from '../../services/resources/operator.service'
import { ApplicationsService } from '../../services/applications.service'
import { L10N_LOCALE, L10nLocale } from 'angular-l10n'
import { ActivatedRoute } from '@angular/router'
import { NavigateService } from '../../services/utils/navigate.service'

@Component( {
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.scss']
} )
export class LogoutComponent implements OnInit {

    public applicationId: string | null = null

    constructor (
        @Inject( L10N_LOCALE ) public locale: L10nLocale,
        private route: ActivatedRoute,
        public localStorageService: LocalStorageService,
        public operatorService: OperatorService,
        public navigateService: NavigateService,
        public applicationsService: ApplicationsService
    ) {
    }

    ngOnInit () {
        this.route.queryParams.subscribe(params => {
            if ( params['applicationId'] && params['applicationId'] !== '' ) {
                this.applicationId = params['applicationId']
            } else {
                this.applicationId = this.localStorageService.getApplicationId()
            }
        })
        this.applicationsService.deleteCurrentApplication()
        this.operatorService.logout( {
            closeEndpoint: true,
            deleteEndpointTimeslots: { delete: true },
            redirect: false,
            deleteStorage: true
        } )
    }

}
